import {loadNextTimelineEntries} from "./loadNextTimelineEntries";
import {addReadMoreButton} from "./addReadMoreButton";
export function lazyLoadFunction() {
    if (typeof lazyLoad !== 'undefined') {
        lazyLoad = !!lazyLoad;
        if (lazyLoad === true && endOfPage === false) {
            var scroll = $(window).scrollTop() + $(window).height();
            var height = $(document).height();
            var aboveBottom = 500;
            if (pageCount < maxPageCount) {
                if ((scroll >= height - aboveBottom)) {
                    lazyLoad = false;
                    loadNextTimelineEntries();
                }
            } else {
                addReadMoreButton();
            }
        }
    }
}